import SVG from "../SVG";

export default function InputAdmin({
  label,
  id,
  name,
  type,
  selectOptions = [],
  selectPlaceHolder,
  inputClassName,
  value,
  onClick,
  onChange,
  isLtr = false,
  readOnly = false,
  disabled = false,
}) {
  const Options = [selectPlaceHolder, ...selectOptions];

  return (
    <div className="w-full flex flex-col gap-2.5">
      <label
        htmlFor={id}
        className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50"
      >
        {label}
      </label>
      {type !== "select" && (
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onClick={onClick}
          onChange={onChange}
          readOnly={readOnly}
          disabled={disabled}
          className={`w-full rounded-lg py-1 px-2.5 border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark appearance-none bg-transparent ${inputClassName} ${
            isLtr && "[direction:ltr]"
          }`}
        />
      )}
      {type === "select" && (
        <div className="relative inline-flex items-center w-full">
          <select
            id={id}
            name={name}
            defaultValue={""}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`w-full rounded-lg py-1 px-2.5 border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark appearance-none bg-transparent cursor-pointer ${inputClassName}`}
          >
            {Options.map((opt, index) => (
              <option
                key={index}
                value={index === 0 ? "" : opt}
                disabled={index === 0}
                className="text-zi-text-light"
              >
                {opt}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute left-3 flex items-center">
            <SVG
              name="select"
              classname="size-3 stroke-zi-text-light dark:stroke-zi-text-dark"
            />
          </div>
        </div>
      )}
    </div>
  );
}
